import { sellerApi } from "./api";

export const getNotificationsApi = async (page = 1) => {
  const { data } = await sellerApi.get("/api/v1/notifications", { params: { page } });
  return data;
};

export const getUnreadCountApi = async () => {
  const { data } = await sellerApi.get("/api/v1/notifications/unread-count");
  return data;
};

export const markAsReadApi = async (id) => {
  const { data } = await sellerApi.put(`/api/v1/notifications/${id}/read`);
  return data;
};

export const markAllAsReadApi = async () => {
  const { data } = await sellerApi.put("/api/v1/notifications/read-all");
  return data;
};
